import { createSlice } from '@reduxjs/toolkit';

const adminAuthSlice = createSlice({
  name: 'adminAuth',
  initialState: {
    token: localStorage.getItem('adminToken') || null,
    admin: JSON.parse(localStorage.getItem('adminUser')) || null,
  },
  reducers: {
    setAdminCredentials: (state, action) => {
      state.token = action.payload.token;
      state.admin = action.payload.admin;
      localStorage.setItem('adminToken', action.payload.token);
      localStorage.setItem('adminUser', JSON.stringify(action.payload.admin));
    },
    clearAdminCredentials: (state) => {
      state.token = null;
      state.admin = null;
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
    },
  },
});

export const { setAdminCredentials, clearAdminCredentials } = adminAuthSlice.actions;
export default adminAuthSlice.reducer;
